import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FindControlAdditionalSearchParametersType, FindControlSearchDto } from 'webcommon/shared';
import { FindControlRepository } from 'webcommon/webapi';

export const isUniqueValidator = (
  findControlRepository: FindControlRepository,
  validationName: string,
  findControlId: string,
  listItem: any
) => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const currentListItemId = listItem?.Id || null;
    const currentValue = control.value.trimEnd().toLowerCase();
    // Timer 500 used for debounce value changes and making api request only when value is stable
    return timer(500).pipe(
      switchMap(() => {
        // Check if every fields has some values to make a API call
        if (typeof currentValue === 'string' && currentValue.length > 0) {
          // Prepare data
          const searchDto: FindControlSearchDto = {
            AdditionalSearchParameters: {
              Type: FindControlAdditionalSearchParametersType.Standard,
              AdditionalSearchParameters: [
                {
                  ColumnName: validationName,
                  Value: currentValue,
                },
              ],
            },
            Prepopulate: false,
            RequiredSearchParameters: null,
            SearchText: '',
            ShowInactive: true,
          };

          // Make search and find duplicates
          return findControlRepository.getData(findControlId, searchDto).pipe(
            map((response) => {
              const isDuplicate = response.Rows.some((item) => {
                // When search return same List Item, ignore it
                const itemId = item?.Id || item?.Pk || null;
                if (currentListItemId != null && itemId != null && currentListItemId === itemId) {
                  return false;
                } else if (validationName in item && typeof item[validationName] === 'string') {
                  return currentValue === item[validationName].trimEnd().toLowerCase();
                }
                return false;
              });
              if (isDuplicate) {
                return { isUnique: true };
              }
              return null;
            }),
            catchError(() => of(null))
          ) as Observable<ValidationErrors | null>;
        }
        return of(null);
      })
    );
  };
};
